module.exports = __webpack_public_path__ + "img/mishaonthebed.7ff4524f.jpg";